import { render, staticRenderFns } from "./Feeds.vue?vue&type=template&id=e2aaec20&scoped=true&"
import script from "./Feeds.vue?vue&type=script&lang=js&"
export * from "./Feeds.vue?vue&type=script&lang=js&"
import style0 from "./Feeds.vue?vue&type=style&index=0&id=e2aaec20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2aaec20",
  null
  
)

export default component.exports